<template>
  <div class="factory__line" @click="setfeaturedfactory(factory.id)">
    <span>{{factory.business_name}}</span>
    <i v-if="factory.preferred" class="material-icons">stars</i>
  </div>
</template>

<script>
import {store} from '@/store'
export default {
  name: 'FactoryLine',
  props: {
    factory: Object
  },
  methods: {
    setfeaturedfactory: function(id) {
      store.dispatch('setFactory', id)
      store.dispatch('setRepGroup')
      store.commit('togglesidebar')
    }
  }
}
</script>

<style scoped lang="less">
  .factory__line {
    display: block;
    position: relative;
    width: 100%;
    box-sizing: border-box;
    padding: 12px 24px;
    border-bottom: dashed 1px lightgray;
    cursor: pointer;
  }

  i {
    position: absolute;
    top: 9px;
    right: 12px;
    color: lightgray;
  }
</style>



// WEBPACK FOOTER //
// src/components/mainpage/FactoryLine.vue